const changeBgColor = theme => {
    if (theme === 'dark') {
      return 'linear-gradient(120deg, #1b293b 30%, #223342 38%, #223342 40%, #1b293b 48%)'
    }
    else {
      return 'linear-gradient(120deg,#e5e5e5 30%,#f0f0f0 38%,#f0f0f0 40%,#e5e5e5 48%);'
    }
  };


export {changeBgColor}